var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWellness = function SvgWellness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Wellness_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.201 18.479 16.192 10.8c-.685.38-1.37.757-2.055 1.14l3.985 7.648c.69-.38 1.383-.75 2.08-1.109Z",
    fill: "#FFC417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.707 20.773 8.713 17.43c-.28.733-.568 1.462-.846 2.191l7.96 3.328c.29-.73.585-1.451.88-2.177Z",
    fill: "#FDC6D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.968 24.412 8.5-1.66c-.17-.767-.342-1.53-.513-2.294l-8.467 1.64c.165.78.322 1.547.48 2.314Z",
    fill: "#86BAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.493 20.697 4.067-7.648-2.103-1.044-4.047 7.617c.713.357 1.398.712 2.083 1.075Z",
    fill: "#009C6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.908 27.233c-.037-1.883-.86-3.715-2.655-4.632-1.796-.918-3.964-.787-5.825 0-2.083.866-3.878 2.396-5.335 4.047a17.302 17.302 0 0 0-3.279 5.522 26.542 26.542 0 0 0-1.103-3.729c-.644-1.711-1.45-3.423-2.69-4.83-1.14-1.28-2.758-2.26-4.564-2.198a6.368 6.368 0 0 0-4.584 2.362c-2.741 3.232-1.713 7.874-.764 11.578a78.702 78.702 0 0 0 4.163 11.842c1.885 4.341 4.047 8.56 6.229 12.773a.774.774 0 0 0 .305.322.873.873 0 0 0 1.511.38A114.795 114.795 0 0 0 47.31 39.075a133.88 133.88 0 0 0 2.741-5.755c.853-1.917 1.895-3.965 1.857-6.087Z",
    fill: "#FF7D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.318 33.008a.683.683 0 0 0-.168.028c-.61.13-.908.969-.983 1.5-.07.295-.043.606.075.886a.867.867 0 0 0 .956.342c.593-.126.983-1.236.977-1.852a.996.996 0 0 0-.13-.592.84.84 0 0 0-.727-.312ZM40.837 33.888a.912.912 0 0 0-.167.031c-.61.13-.908.966-.984 1.5-.07.296-.043.606.076.886a.873.873 0 0 0 .956.343c.589-.13.983-1.236.976-1.856a.978.978 0 0 0-.13-.589.84.84 0 0 0-.727-.315Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.694 38.53a48.72 48.72 0 0 1-.552 1.606c-.606 1.496-1.432 3.8-2.237 4.314a1.744 1.744 0 0 1-2.025-.028c-.641-.496-.782-1.81-.778-2.581a9.968 9.968 0 0 1 .12-1.496c.04-.52.222-1.917.343-2.427l-2.2-.23c-1.028 3.266-1.32 8.419 2.467 9.288 4.166.959 5.955-3.266 6.811-6.505.082-.311.216-.961.316-1.468-.775-.158-1.522-.301-2.265-.473Z",
    fill: "#FDC6D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Wellness_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.867 10.8)",
    d: "M0 0h57.6v50.175H0z"
  })))));
};
export default SvgWellness;